
<script>
import BarList from '../components/bar-list'
import { apiORDSdelete } from '../shared/api-functions'
import { SysVars } from '../main';
import TemplateEmailForm from './template-email-form'
import apiCrm from '../api/api-crm.js'

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            codtempl: null,
        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        templEmailList: function () {
            return this.$store.getters.getTemplEmailList
        },
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },
    },

    methods: {
        handleEdit (template) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.codtempl = template.codtempl
            this.showForm = true
        },

        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.codtempl = null
            this.showForm = true
        },

        closeForm(template) {
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codtempl":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadTemplEmail', { filter: this.filter, page: this.nextPage } )
            this.offset = ''
        },

        handleDelete (template) {
            //BOTAO Excluir
            this.apiTemplateDelete(templemail.codtempl)
            this.loadData()
        },

    },

    components: {
        BarList, TemplateEmailForm
    },

    mounted () {
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="false"
                single-entity="Template de Email" 
                plural-entity="Templates de Email"
                @search="search"
                @new="handleNew"
                @refresh="loadData">
            </bar-list>
            <br>
            <div class="default-container">
                <alert v-if="templEmailList.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="template in templEmailList" :key="template.codtempl">
                    <div class="box">
                        <div class="row">
                            <div class="col-md-10 col-6">
                                <!-- <span class="lbl-list"> {{metadata.templemail.descricao.label}} </span> -->
                                <span class="lbl-title-produto">{{ template.descricao }}</span>
                                <div class="w-100"></div>
                                <span class="lbl-list-detalhe pr-2"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ template.data | formatDataHoraExtenso }}</span>
                                <span class="lbl-list-detalhe"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ template.usuario_nome }}</span>
                            </div>
                            <div class="col-md-2 col-6">
                                <bar-grid 
                                    :options="{barDefault: true, btnDelete: true, btnEdit: true}" 
                                    :moreActions="[]" 
                                    @edit="handleEdit(template)" 
                                    @delete="handleDelete(template)">
                                </bar-grid>
                            </div>
                            <div class="col-md-12 col-12 mt-3">
                                <span class="data-list pr-2" v-if="template.publico == 'S'"><i class="fa fa-unlock pr-2" aria-hidden="true"></i> Template Público </span>
                                <span class="data-list pr-2" v-else><i class="fa fa-lock pr-2" aria-hidden="true"></i> Template Privado </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template-email-form v-if="showForm" :index="codtempl" :crud="crud" @closeform="closeForm"></template-email-form>
    </div>
</template>

<style>

</style>





// WEBPACK FOOTER //
// src/forms-crm/template-email-list.vue